/**
 * useAsconMonthly — 경원(아스콘) 그 해 월별 출하(톤). 출하조회 우측 "월별 출하량" 카드용.
 *
 * useAsconShipments 와 같은 방식: 결과에 연도를 붙여 두고 지금 연도와 맞을 때만 보여 준다(연도를 바꾸면 옛 값이 바로 사라짐).
 * 폴링하지 않는다(저장소가 같은 해를 1분 동안 한 번만 읽는다). year 0 = 끔.
 */
import { useEffect, useState } from "react";
import type { AsconMonthBucket } from "@/domain/asconShipment";
import { asconShipmentRepo } from "@/services/asconShipment.repository";

interface Result {
  year: number;
  buckets: AsconMonthBucket[];
  error: string | null;
}

const EMPTY: AsconMonthBucket[] = [];

export function useAsconMonthly(year: number): { buckets: AsconMonthBucket[]; loading: boolean; error: string | null } {
  const [res, setRes] = useState<Result | null>(null);
  useEffect(() => {
    if (!year) return; // 0 = 끔(useMonthlyShipments 와 같은 약속)
    let alive = true;
    asconShipmentRepo.fetchMonthly(year).then(
      (r) => { if (alive) setRes({ year, buckets: r.buckets, error: null }); },
      (e: unknown) => { if (alive) setRes({ year, buckets: EMPTY, error: e instanceof Error ? e.message : String(e) }); },
    );
    return () => { alive = false; };
  }, [year]);
  const cur = res && res.year === year ? res : null;
  return { buckets: cur?.buckets ?? EMPTY, loading: Boolean(year) && !cur, error: cur?.error ?? null };
}
